import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import * as wConsts from "../consts/website-consts";
import NotFound from "../components/notfound";
import SwBanner from "../components/swbanner";
import BuyAdBanner from "../components/buyadbanner";
import Flag from 'react-flags';
import * as wActs from "../actions/website-actions";
import {Link} from "react-router-dom";
import SeoHeaders from "../components/seoheaders";


class Home extends Component {

  componentDidMount() {
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "home" });

  }


  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }



  render() {

    if(this.props.WebPage.PageLoaded && this.props.WebPage.Page.Name === "404") {
      return <NotFound />;
    }

    let pcks = [];
    if(this.props.Packs.Loaded && this.props.Packs.Code == 200) {
      pcks = this.props.Packs.Result;
    }

    console.log("Packs",pcks)

    let logo = "/imgs/logo-ads1k.svg";
    if(this.props.WebPage.Settings.Domain.indexOf("escort")>-1) {
      logo = "/imgs/logo.png"
    }

    let showBan = this.props.WebPage.Settings.ShowRightBanners;
    let isAdult = wActs.isAdult(this.props.WebPage);

    return (
      <React.Fragment>
        <div className="hero">
          <div className="container">
            <div className="logo">
              <img src={logo} alt={this.props.WebPage.Settings.SeoName}/>
            </div>
            {typeof window == "undefined" && <h1 dangerouslySetInnerHTML={{__html: this.props.WebPage.Page.Content.Text1}}></h1>}
            {typeof window != "undefined" && <h1 ref={(r) => {this.Header = r}}></h1>}
            <p ref={(r) => {this.Text2 = r}}></p>
            <div className="scroll-down">
              {isAdult && <i className="fas fa-angle-down"></i>}
            </div>
          </div>
        </div>

        {isAdult &&
        <div className="section package-section">
          <div className="container">

            <div className="heading">
              <h2>{this.props.WebPage.Page.Content.NetworkAndSupportPlatforms}</h2>
              <p ref={(r) => {this.WeWork = r}}></p>
            </div>

            <div className="boxes">
              {isAdult &&
              <div className="box-row" style={{display: "flex", flexWrap: "wrap", justifyContent: "center"}}>
                <SwBanner maxStandard={"30"} count={"30"} apiAnonId={this.props.WebPage.Request.AnonymousId}
                          tagText={this.props.WebPage.Settings.HtmlSections['Adserver-300x100-ournetwork']}
                          className={"network-banners"} ApiReferer={this.props.WebPage.ServerParams.Referer}></SwBanner>
              </div>
              }


              {/*pcks.map((v,i) => {
                let size = "Profile";
                let cc = "ALL";
                if(v.size!="480x640") { size = v.size; }
                if(!wActs.isNullOrEmpty(v.country.code)) {
                  cc = v.country.code;
                }
                return (
                  <div key={`packagebox-${i}`} className="cell by6">
                    <div className="box">
                      <div className="title">
                        <h6>{v.header.length>15 ? v.header.substr(0,25) : v.header }</h6>
                        <div className="flag">
                          <Flag
                            name={v.country.code == "" ? "EU" : v.country.code}
                            format="png"
                            pngSize={24}
                            shiny={true}
                            alt={`${v.country.name}`}
                            basePath = {"/imgs/flags"}
                          />
                        </div>
                      </div>
                      <div className="info">
                        <p className="price">{v.amount}&euro;</p>
                        <p className="description">{v.shortName}</p>
                        <p className="note">{v.description}</p>
                      </div>
                      <div className="icons">
                        <img src="/imgs/icon-monitor.png" alt="monitor"/>
                        <img src="/imgs/icon-phone.png" alt="phone"/>
                      </div>
                      <a href="#" onClick={(e)=>{
                        //{wActs.getCultPath(this.props.WebPage,`/advertise?country=${cc}&size=${size}&packId=${v.PackageId}`)}
                        e.preventDefault();
                        let obj = {
                          country: cc, size: size, packageId: v.packageId
                        };
                        let isAdult = wActs.isAdult(this.props.WebPage);
                        this.props.dispatch({type: wConsts.ACTION_SETAD_PARAMS, payload: obj});
                        setTimeout(()=>{
                          if(isAdult) {
                            this.props.history.push("/advertise");
                          } else {
                            this.props.history.push("/support");
                          }
                        },750)
                      }} className="default-btn full-btn">{this.getTranslation("page.advertise.buynow")}</a>
                    </div>
                  </div>
                );
              })*/}

              <div className="clear"></div>
            </div>
          </div>
        </div>
        }

        <div className="section split-section">
          <div className="image" style={{backgroundImage: "url(/imgs/about.jpg)"}}></div>
          <div className="text">
            <h2>{this.props.WebPage.Page.Content.AboutUsHeader}</h2>
            <p ref={(r) =>{this.AboutUsText = r}}></p>
            <Link to={wActs.getCultPath(this.props.WebPage, "/advertise")} className="default-btn">{this.props.WebPage.Page.Content.DoYouWantMorePower}</Link>
          </div>
        </div>
        <div className="section split-section">
          <div className="text">
            <h2>{this.props.WebPage.Page.Content.HowItWorksHeader}</h2>
            <p ref={(r) =>{this.HowItWorksText = r}}></p>
          </div>
          <div className="image" style={{backgroundImage: "url(/imgs/how-works.jpg)"}}></div>
        </div>

        {false &&
        <div className="section network-section">
          <div className="container">
            <div className="small-wrap">
              <div className="heading">
                <h2>{this.props.WebPage.Page.Content.NetworkAndSupportPlatforms}</h2>
                <p ref={(r) => {this.WeWork = r}}></p>
              </div>
              <div className="boxes">
                <div className="box-row" style={{display: "flex", flexWrap: "wrap"}}>
                  <SwBanner maxStandard={"30"} count={"30"} apiAnonId={this.props.WebPage.Request.AnonymousId} tagText={this.props.WebPage.Settings.HtmlSections['Adserver-300x100-ournetwork']} className={"network-banners"} ApiReferer={this.props.WebPage.ServerParams.Referer}></SwBanner>
                </div>
              </div>
            </div>
          </div>
        </div>
        }

        <SeoHeaders Position={"Bottom"}/>


      </React.Fragment>
  );
  }
  componentDidUpdate() {
    try {
      if(typeof window !== "undefined" && !wActs.isNullOrEmpty(this.props.WebPage.Page.Content.Text1)) {
        let showBan = this.props.WebPage.Settings.ShowRightBanners;
        const range1 = document.createRange();
        if(showBan) { this.WeWork.innerHTML = ""; this.WeWork.appendChild(range1.createContextualFragment(this.props.WebPage.Page.Content.WeWorkWithTheBest)); }
        this.Header.innerHTML = ""; this.Header.appendChild(range1.createContextualFragment(this.props.WebPage.Page.Content.Text1));
        this.Text2.innerHTML = ""; this.Text2.appendChild(range1.createContextualFragment(this.props.WebPage.Page.Content.Text2));
        this.AboutUsText.innerHTML = ""; this.AboutUsText.appendChild(range1.createContextualFragment(this.props.WebPage.Page.Content.AboutUsText));
        this.HowItWorksText.innerHTML = ""; this.HowItWorksText.appendChild(range1.createContextualFragment(this.props.WebPage.Page.Content.HowItWorksText));
      }
    } catch(ex) {}
  }

}


const mapStateToProps = (state) => {
  return {
    SelectedLocal: state.Website.Settings.SelectedLocal,
    ProfilePath: state.Website.ProfilePath,
    WebPage: state.Website,
    Packs: state.Ads.PopularPackages
  };
};

export default connect(mapStateToProps)(Home);
